import { isDateValid, isFutureDate, isBeforeLongAgo, isMonthYearValid } from "src/utils/date"
import { aboutAttorneyPrivatePractice } from "src/constants/application"
import { boolean } from "yup"
export const handleYesNoAnswers = (answer: boolean | undefined) => {
  if (answer === undefined || answer === null)
    return 'N/A'

  if (answer === true)
    return 'Yes'

  if (answer === false)
    return 'No'
}

export const validateDateField = (date?: string, allowFuture = false, length = 10, isDateRequired : boolean = true): string => {
  
  let _date = date === undefined ? "" : date.trim()
  const datePattern = /(0\d{1}|1[0-2])\/([0-2]\d{1}|3[0-1])\/(19|20)\d{2}/
  let _dateMatch = date?.match(datePattern);

  if (!_dateMatch) {
    return 'Please input date in MM/DD/YYYY format'
  }

  if(isDateRequired && _date.length !== length){ 
    return 'Please input date in MM/DD/YYYY format'
  }

  if(!isDateRequired && !_date && _date.length === 0)
  {
    return ''
  }

  if (!_date && isDateRequired) {
    return 'This is a required field'
  }

  if (_date?.trim()?.length  < length ||
    !isDateValid(_date) ||
    isBeforeLongAgo(_date) ||
    (isFutureDate(_date) && !allowFuture)) {
    return 'Please input date in MM/DD/YYYY format'
  }
  return ''
}

export const validateOptionalDate = (date?: string | undefined| null) :boolean =>{
  date = date === null ? undefined : date
  const datePattern = /(0\d{1}|1[0-2])\/([0-2]\d{1}|3[0-1])\/(19|20)\d{2}/
  let _dateMatch = date?.match(datePattern);

  if(date === undefined){
    return true
  }else if(date === ''){
    return true
  }else if(date !== '' && date.length < 10){
    return false
  }else if(!_dateMatch) {
    return false;
  }

    return true
}

export const isInValidHours = (hours?: number): boolean => {
  if (hours === undefined) {
    return true
  }

  if (hours < 0 || hours > 99) {
    return true
  }

  return false
}

export const validateMonthYearField = (date?: string, allowFuture = false, length = 7): string => {
  if (!date) {
    return 'This is a required field'
  }
  if (date.trim().length < length ||
    !isMonthYearValid(date) ||
    isBeforeLongAgo(date, true) ||
    (isFutureDate(date, true) && !allowFuture)) {
    return 'This is not a valid date'
  }
  return ''
}

export function lookupYearsInPrivatePractice(index: any) {
  if ((typeof index).match(/number|string/)) {
    return aboutAttorneyPrivatePractice[Number(index)]
  }
  return '';
}